import {
  faTableCellsLarge,
  faTableList,
} from '@fortawesome/free-solid-svg-icons';

import { useTitlesViewContext } from '»utils/customHooks';

import { ButtonGroupContainerStyled, ButtonViewStyled } from '../Styles';
import { ButtonIconStyled } from '../Styles/Buttons.styles';

export const ButtonsViewSelector = () => {
  const { titlesView, setTitlesView } = useTitlesViewContext();

  return (
    <ButtonGroupContainerStyled
      variant="contained"
      id="stockExchangeViewSelector"
    >
      <ButtonViewStyled
        onClick={() => setTitlesView('table')}
        selected={titlesView === 'table'}
      >
        <ButtonIconStyled icon={faTableList} />
      </ButtonViewStyled>
      <ButtonViewStyled
        onClick={() => setTitlesView('cards')}
        selected={titlesView === 'cards'}
      >
        <ButtonIconStyled icon={faTableCellsLarge} />
      </ButtonViewStyled>
    </ButtonGroupContainerStyled>
  );
};
